import React from 'react';
import { CustomDashboard } from '../../../app/pages/Dashboard/CutsomDashboard';

export function Dashboard() {
    return <CustomDashboard/>
}
